export const TOGGLE_SOUND = 'TOGGLE_SOUND';
export const START_TRANSITION_PLAYING = 'START_TRANSITION_PLAYING';
export const STOP_TRANSITION_PLAYING = 'STOP_TRANSITION_PLAYING';
export const AUDIO_LOADED = 'AUDIO_LOADED';



// WEBPACK FOOTER //
// ./src/actionCreators/soundActionNames.js